<script lang="ts">
  import { ui } from "../lib/stores/ui.svelte.js";
  import Sheet from "./Sheet.svelte";

  const request = $derived(ui.promptRequest);
  let value = $state("");

  $effect(() => {
    if (request) value = request.value;
  });

  function submit(event: SubmitEvent): void {
    event.preventDefault();
    request?.resolve(value);
  }
</script>

{#if request}
  <Sheet title={request.title} onclose={() => request.resolve(null)} width={420}>
    <form class="body" onsubmit={submit}>
      <h2>{request.title}</h2>
      <label class="field"
        >{request.label}
        <input
          class="input"
          bind:value
          maxlength={request.maxLength}
          required
          autocomplete="off"
          enterkeyhint="done"
          onfocus={(e) => e.currentTarget.select()}
        /></label
      >
      <div class="actions">
        <button type="button" class="btn btn-ghost" onclick={() => request.resolve(null)}>Abbrechen</button>
        <button type="submit" class="btn btn-primary" disabled={!value.trim()}>{request.confirmLabel}</button>
      </div>
    </form>
  </Sheet>
{/if}

<style>
  .body {
    padding: 4px 8px 4px;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  h2 {
    font-size: 22px;
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 4px;
  }
</style>
